import { createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  startDate: subDays(new Date(), 30),
  endDate: new Date(),
  CardOfferExcelSendModal: false,
  storeId: "",
  offerId: "",
  totalCount: "",
};

const cardOfferSlice = createSlice({
  name: "cardOffer",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});
export const { updateConfig } = cardOfferSlice.actions;
export default cardOfferSlice.reducer;
